export const isNotEmpty = (value?: string) =>
  value && value !== "";
